import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { components } from 'react-select';
import { useTranslation } from 'react-i18next';

const Option = ({ selectedFreelancers, ...props }) => {
    const getPopoverHeaderText = () => {
        if (selectedFreelancers?.length === undefined) {
            return t('You Can Select Up to 15 Freelancers');
        }
        if (selectedFreelancers?.length === 15) {
            return t('You Have Selected 15 Freelancers');
        }
        return '';
    };
    const { t } = useTranslation();

    return (
        <OverlayTrigger
            placement="right"
            overlay={
                <Popover style={{ margin: 0 }}>
                    <Popover.Header
                        className={selectedFreelancers?.length === undefined ? 'text-primary-custom' : 'text-danger'}
                        as="h3"
                    >
                        {getPopoverHeaderText()}
                    </Popover.Header>
                </Popover>
            }
        >
            <span>
                <components.Option {...props} />
            </span>
        </OverlayTrigger>
    );
};

export default Option;
